export default {
  "content": "<path fill=\"#6d7276\" fill-rule=\"evenodd\" d=\"M12.98 10.79l-4.603 5.02c-.014.02-.01.049-.028.066a.393.393 0 01-.301.116.394.394 0 01-.298-.116c-.019-.017-.015-.045-.028-.065l-4.604-5.02a.402.402 0 01.568-.568l4.364 4.76 4.366-4.76a.4.4 0 11.565.567zm.003-5.019a.398.398 0 01-.567 0L8.049 1.013 3.686 5.771a.402.402 0 01-.568-.567L7.722.184c.014-.02.01-.047.028-.066a.397.397 0 01.299-.114.392.392 0 01.3.114c.019.019.015.047.028.067l4.604 5.02c.159.157.159.41.002.566z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};